(function () {
  'use strict';

  function init(root) {
    if (root.dataset.essentialsReady || !window.fetch || !window.DOMParser) return;
    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;
    root.dataset.essentialsReady = 'true';

    root.querySelectorAll('[data-essential-group]').forEach(function (group) {
      var button = group.querySelector('[data-essential-more]');
      var count = group.querySelector('[data-essential-count]');
      var feedback = group.querySelector('[data-catalog-feedback]');
      var message = group.querySelector('[data-catalog-message]');
      var recovery = group.querySelector('[data-catalog-retry]');
      var heading = group.querySelector('h2') || root.querySelector('h1');
      var title = heading ? heading.textContent : '';
      var busy = false;

      function parts() { return Array.from(group.querySelectorAll('[data-catalog-part]')); }
      function nextPart() { return parts().find(function (part) { return part.dataset.catalogNextUrl; }); }
      function refresh() {
        var loaded = group.querySelectorAll('.product-card').length;
        var total = parts().reduce(function (sum, part) { return sum + Number(part.dataset.catalogTotal || 0); }, 0);
        count.textContent = (loaded < total ? loaded + ' / ' : '') + total + ' ' + root.dataset.productLabel;
        button.hidden = !nextPart();
        button.disabled = busy;
        button.textContent = busy ? root.dataset.loadingLabel : root.dataset.moreLabel;
        button.setAttribute('aria-label', button.textContent + ' — ' + title);
      }

      button.addEventListener('click', async function () {
        if (busy) return;
        var part = nextPart();
        if (!part) return;
        var pageUrl = new URL(part.dataset.catalogNextUrl, window.location.href);
        if (pageUrl.origin !== window.location.origin) return;
        recovery.href = pageUrl.href;
        busy = true;
        group.setAttribute('aria-busy', 'true');
        feedback.hidden = true;
        refresh();
        var controller = window.AbortController ? new AbortController() : null;
        var timer = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
        try {
          var fetchUrl = new URL(pageUrl.href);
          fetchUrl.hash = '';
          fetchUrl.searchParams.set('sections', sectionId);
          var response = await fetch(fetchUrl.href, { credentials: 'same-origin', signal: controller ? controller.signal : undefined });
          if (!response.ok) throw new Error('Catalog section request failed');
          var sections = await response.json();
          if (typeof sections[sectionId] !== 'string') throw new Error('Catalog section is unavailable');
          var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
          var incoming = doc.getElementById(part.id);
          if (!incoming || Number(incoming.dataset.catalogPage) !== Number(part.dataset.catalogPage) + 1) {
            throw new Error('Unexpected catalog page');
          }
          var cards = Array.from(incoming.children).filter(function (child) { return child.classList.contains('product-card'); });
          if (!cards.length) throw new Error('No additional products returned');
          var firstLink = cards[0].querySelector('a');
          var oldPagination = part.querySelector('[data-catalog-pagination]');
          var newPagination = incoming.querySelector('[data-catalog-pagination]');
          var preservePrevious = oldPagination && oldPagination.hasAttribute('data-has-previous');
          var fragment = document.createDocumentFragment();
          cards.forEach(function (card) { fragment.appendChild(card); });
          part.insertBefore(fragment, oldPagination);
          if (oldPagination) oldPagination.remove();
          // Previous-page navigation is only needed for a directly loaded page.
          // After appending, those earlier cards are already present in this container.
          if (newPagination) {
            if (!preservePrevious) newPagination.removeAttribute('data-has-previous');
            part.appendChild(newPagination);
          }
          part.dataset.catalogPage = incoming.dataset.catalogPage;
          part.dataset.catalogTotal = incoming.dataset.catalogTotal;
          part.dataset.catalogNextUrl = incoming.dataset.catalogNextUrl || '';
          if (firstLink) {
            firstLink.focus({ preventScroll: true });
            firstLink.closest('.product-card').scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        } catch (error) {
          message.textContent = root.dataset.errorLabel;
          feedback.hidden = false;
        } finally {
          if (timer !== null) window.clearTimeout(timer);
          busy = false;
          group.removeAttribute('aria-busy');
          refresh();
        }
      });

      group.dataset.catalogReady = 'true';
      refresh();
    });
  }

  document.querySelectorAll('[data-essentials-shop]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-essentials-shop]').forEach(init);
  });
})();
